import React, { useEffect, useState } from 'react'; 
import Sidebar from './Sidebar';
import styles from './../../Assets/CSS/Style.module.css'; 
import axios from 'axios';
import { BASE_URL } from './../../Environment';
import { toast } from 'react-toastify'; 
import Info from './Info';
import walletImage from './../../Assets/Images/wallet.svg'; 
import { FaCheckCircle } from 'react-icons/fa'; 
 
function Wallet() { 
    const [isLoading, setIsLoading] = useState(false);  
    const accessToken = localStorage.getItem('accessToken'); 
    const [wallet, setWallet] = useState([]);  
    useEffect(() => {   
        document.title = 'Infomart | Agent Wallet';    
        setIsLoading(true);   
        axios.get(`${BASE_URL}/agent/wallet`, { 
            headers: { 
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`  
            } 
        }).then((res) => {
            setWallet(res.data.data); 
            setIsLoading(false); 
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 }); 
            setIsLoading(false);
        });        
    }, []);  
    return (
        <div className="app">
            <div className="outlet"> 
                <Info />
                <div className="homeLayout">
                    <Sidebar />
                    {isLoading ?
                        <h5 className="text-center mt-5">Loading...</h5>
                    :
                        <div className={styles.walletPageContainer}>
                            <h4 className="mb-3" style={{whiteSpace:'nowrap'}}>My Wallet</h4>
                            <div className={styles.walletPageContent}>
                                <div className={styles.walletPageCard}>
                                    <div className={styles.walletCardHeader}>
                                        <div>Your Balance</div>
                                    </div>
                                    <div className={styles.walletCardContent}> 
                                        <div className={styles.walletInnerCard}>
                                            <div className={styles.walletInnerCardTop}>
                                                <img src={walletImage} height={80} width={80} alt="" />
                                            </div>  
                                            <div className={styles.walletInnerCardBottom}>
                                                <div className={styles.row}> 
                                                    <div className="fw-bold text-muted fs-1">₹{wallet}.00</div>
                                                </div>    
                                                <div className={styles.row}>
                                                    <FaCheckCircle color="green" />
                                                    <div className="mx-1">Active</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                            </div> 
                        </div> 
                    } 
                </div>
            </div> 
        </div>
    );
}

export default Wallet;      